import {
  getBody,
  getFeedbackOpen
} from 'actions/communication/feedback/feedbackSelectors';
import { getEmail, getFullName } from 'actions/auth/login';
import {
  sendEmail,
  setBody,
  toggleModal
} from 'actions/communication/feedback/feedbackActions';
import FeedbackComponent from './FeedbackComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  feedbackOpen: getFeedbackOpen(state),
  fullName: getFullName(state),
  email: getEmail(state),
  body: getBody(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleModal,
      setBody,
      sendEmail
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const FeedbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackComponent);

export default FeedbackContainer;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/FeedbackContainer.js